import { createIcon } from './create-icon'

export const Medium = createIcon({
  displayName: 'Medium',
  paths: [
    'M744.947 504.678c7.253 5.12 15.36 7.249 23.467 7.249 13.653 0 27.307-6.822 35.413-19.191 12.8-19.618 7.68-46.059-11.947-59.281l-256-170.595c-14.507-9.383-32.853-9.383-47.36 0l-256.001 170.595c-19.627 13.222-25.173 39.663-11.947 59.281s39.68 25.165 59.307 11.942l232.535-154.815 232.533 154.815zM744.947 760.572c7.253 5.12 15.36 7.249 23.467 7.249 13.653 0 27.307-6.822 35.413-19.191 12.8-19.618 7.68-46.059-11.947-59.281l-256-170.594c-14.507-9.382-32.853-9.382-47.36 0l-256.001 170.594c-19.627 13.222-25.173 39.663-11.947 59.281s39.68 25.165 59.307 11.942l232.535-154.816 232.533 154.816z'
  ]
})
